export default "__VITE_ASSET__bc06f8d0__"